module.exports = __webpack_public_path__ + "static/media/pause.0d4325d9.svg";